import { BrowserRouter } from 'react-router-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import throttle from 'lodash/throttle'

import App from './App'
import { loadState, saveState } from './localStorage'
import reducer from './reducers'
import registerServiceWorker from './registerServiceWorker'

// import './index.css'

// eslint-disable-next-line no-underscore-dangle

 import * as mdc from 'material-components-web';
 mdc.autoInit();
 window.mdc = mdc;

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const logger = store => next => (action) => {
  console.group(action.type)
  console.info('dispatching', action)
  const result = next(action)
  // console.log('next state', store.getState())
  console.groupEnd(action.type)
  return result
}

const persistedState = loadState()
const store = createStore(
  reducer,
  persistedState,
  composeEnhancers(applyMiddleware(logger)),
)

store.subscribe(throttle(() => {
  saveState(store.getState())
}, 1000))

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js